module.exports = __webpack_public_path__ + "img/woman-g319202414_1920.2a0b8bd8.jpg";